import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Heading from 'components/Heading';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is a light wrapper around the Heading component used
 * by some Card components.
 * It's intentionally kept simple and only allows customising
 * its margin. If you're building a new Card component and
 * this component doesn't quite work for it, consider using
 * the `Heading` or `Text` components directly rather than
 * making this component more configurable.
 */

export var CardTitle = function CardTitle(_ref) {
  var children = _ref.children,
    ref = _ref.ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({
    ref: ref,
    as: "h3",
    size: "small",
    lineHeight: 1.3
  }, otherProps), {}, {
    children: children
  }));
};
CardTitle.displayName = 'CardTitle';